import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconJump: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"jump, skip"} maskId="square-filled-radius-0-stroke-1-IconJump"><path d="M22 11H21V5.67676C16.5667 9.71904 13.2232 13.7048 12.5566 19H17V20H7V19H11.4922C11.3896 15.8318 10.0945 12.8796 8.18555 10.6924C6.19103 8.40714 3.5691 7 1 7V6C3.9309 6 6.80897 7.59317 8.93945 10.0342C10.428 11.7397 11.5708 13.8806 12.127 16.2354C13.4508 11.8788 16.5447 8.39485 20.2598 5H15V4H22V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconJump;
